<template>
    <div class="subtitle d-flex justify-content-center align-items-center background"
         v-if="show"></div>
</template>

<script>
export default {
    name: 'SubHeader',
    props: {
        show: Boolean
    },
};
</script>

<style lang="scss" scoped>
.subtitle {
    background-color: #f5f5f5;
    font-size: 1.25rem;
    height: 100px;
    @media (max-width: 768px) {
        & {
            height: 19vw;
            min-height: 80px;
        }
    }
}
.background {
    background-image: url('../assets/images/header.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @media (max-width: 768px) {
        & {
            background-image: url('../assets/images/subHeader.jpg');
        }
    }
}
</style>
